<script setup lang="ts">
import { ref, onMounted, onBeforeUnmount } from 'vue'
import L from 'leaflet'
import 'leaflet/dist/leaflet.css'
import { regionConfig } from '@/config/region'

// Two pins, one for the report under review and one for the report it is linked to, fitted into view.
const props = defineProps<{
  /** [latitude, longitude] of the report under review. */
  here: [number, number]
  /** [latitude, longitude] of the other report. */
  there: [number, number]
}>()

const container = ref<HTMLElement | null>(null)
let map: L.Map | null = null

const pin = (color: string, label: string) =>
  new L.DivIcon({
    html: `<i class="q-icon mdi mdi-map-marker" style="font-size:30px;color:${color};filter:drop-shadow(0 1px 3px rgba(0,0,0,0.45))"></i><b style="position:absolute;left:24px;top:2px;font-size:11px;background:#fff;border-radius:3px;padding:0 3px">${label}</b>`,
    iconSize: [30, 30],
    iconAnchor: [15, 30],
    className: ''
  })

onMounted(() => {
  if (!container.value) return
  const { sw, ne } = regionConfig.mapBounds
  map = new L.Map(container.value, {
    maxBounds: [
      [sw.lat, sw.lng],
      [ne.lat, ne.lng]
    ],
    scrollWheelZoom: false
  })
  new L.TileLayer('https://{s}.basemaps.cartocdn.com/light_all/{z}/{x}/{y}{r}.png', {
    attribution: '&copy; OpenStreetMap contributors &copy; CARTO',
    maxZoom: 19
  }).addTo(map)
  new L.Marker(props.here, { icon: pin('#e74c3c', 'This') }).addTo(map)
  new L.Marker(props.there, { icon: pin('#1976d2', 'Linked') }).addTo(map)
  map.fitBounds(L.latLngBounds([props.here, props.there]), { padding: [30, 30], maxZoom: 17 })
})

onBeforeUnmount(() => {
  map?.remove()
  map = null
})
</script>

<template>
  <div ref="container" class="relation-pair-map" data-testid="relation-pair-map" />
</template>

<style scoped>
.relation-pair-map {
  height: 180px;
  width: 100%;
  border-radius: 4px;
}
</style>
